export class ApprovalIdReq{
approvedUserId:number
}